module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-select weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._l((_vm.dList), function(item, index) {
    return _c('option', _vm._b({
      key: index,
      style: ({
        marginTop: _vm._px2rem(index >= _vm.cols ? _vm.lineSpacing : null, 75)
      }),
      attrs: {
        "index": index,
        "data-evt-select": ""
      },
      on: {
        "select": function($event) {
          return _vm.onSelect(index)
        }
      }
    }, 'option', Object.assign({}, _vm.customStyles, item), false))
  }), _vm._v(" "), _vm._l((_vm.cHackList), function(item, index) {
    return _c('option', _vm._b({
      key: _vm.id + index,
      style: ({
        opacity: 0,
        marginTop: _vm._px2rem(_vm.dList.length >= _vm.cols ? _vm.lineSpacing : null, 75)
      }),
      attrs: {}
    }, 'option', Object.assign({}, _vm.customStyles, item), false))
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66f2fd5e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f2fd5e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-grid-select/index.vue
// module id = 632
// module chunks = 0 1